import { render } from "./NewBoxPlan.vue?vue&type=template&id=e5fa13d2&scoped=true"
import script from "./NewBoxPlan.vue?vue&type=script&lang=js"
export * from "./NewBoxPlan.vue?vue&type=script&lang=js"

import "./NewBoxPlan.vue?vue&type=style&index=0&id=e5fa13d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5fa13d2"]])

export default __exports__